import React, { useState, useEffect }  from 'react'
import { Box, Flex, Group, Button, Avatar, Text, FocusTrap } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconTrash } from '@tabler/icons-react'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { addPhotoProfile, updatePhotoProfile, deletePhotoProfile } from '../../../../../services/users'
import { useDispatch } from 'react-redux'
import { getAuthUserLogin } from '../../../../../store/userLogin.js'

const formValidation = {
  avatar: {
    isError: false,
    message: ''
  }
}

const FormAdjustAvatar = ({ dataAvatar, onCloseForm }) => {
  const dispatch = useDispatch()
  const [avatar, setAvatar] = useState(null)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const handleUploadAvatar = async (photoAvatar) => {
    setLoadingForm(true)
    const payload = {
      image_encoded: photoAvatar
    }
    try {
      const response = dataAvatar.images === null ? await addPhotoProfile(dataAvatar.id, payload) : await updatePhotoProfile(dataAvatar.id, payload)
      console.log(response)
      if (response.success) {
        notificationSuccess('Avatar updated successfully', 'You have successfully updated your avatar')
        dispatch(getAuthUserLogin())
        onCloseForm()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Avatar Profile Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleDeleteAvatar = async () => {
    setLoadingForm(true)
    try {
      const response = await deletePhotoProfile(dataAvatar.id)
      console.log(response)
      if (response.success) {
        notificationSuccess('Avatar removed successfully', 'You have been removed your avatar')
        dispatch(getAuthUserLogin())
        onCloseForm()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Removed Avatar Profile Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataAvatar) {
      setAvatar(dataAvatar.images)
    }
  }, [dataAvatar])

  const handleUploadImage = (file) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      setAvatar(reader.target.result)
    }
  }

  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {

        image: {
          isError: true,
          message: errorMessage === 'File is larger than 2000000 bytes'
            ? 'The maximum allowed image size is 2mb'
            : errorMessage
        }
      }
      setValidationForm((oldVal) => ({ ...oldVal, ...error}))
      notificationError('Upload Avatar Error', validationForm.avatar.message)
    }
  }

  const handleRemoveAvatar = () => {
    setAvatar(null)
  }

  return (
    <Box>
      <FocusTrap.InitialFocus />
      <Box ta='center'>
        <Dropzone
            mt={5}
            accept={[
              'image/png',
              'image/jpeg',
              'image/gif',
            ]}
            onDrop={(files) => handleUploadImage(files)}
            onReject={(files) => handleErrorFile(files)}
            maxSize={2000000}
            style={{ border: 'none', backgroundColor: 'transparent' }}
          >
          <Box ta='center' my={30}>
            <Flex justify='center' mb={10}>
              <Avatar variant="outline" radius="100%" size="150" src={avatar} />
            </Flex>
            <Box>
              <Text fz={12} c='blue.9'>Upload Avatar Here</Text>
              <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 2 MB</Text>
            </Box>
          </Box>
        </Dropzone>
      </Box>
      <Box mb={40}>
        <Button fullWidth size='xs' leftSection={<IconTrash size={14} />} variant="filled" onClick={() => handleRemoveAvatar()} disabled={avatar === null}>Remove Avatar</Button>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' variant="filled" loading={loadingForm} onClick={() => avatar !== null ? handleUploadAvatar(avatar) : handleDeleteAvatar()}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustAvatar